import React from 'react';

import { translate as t } from 'admin-on-rest';
import { Field } from 'redux-form';
// import { Field } from 'redux-form';
// import { TextField } from 'material-ui';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import { phone } from '../../utils/StringUtils';

const containerStyle = {
  width: 'auto',
  display: 'inline-block',
};
const inputStyle = {
  width: '230px',
};

export class PhoneNumberInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.input ? props.input.value : '' };
  }

  handleChange = (value) => {
    this.setState({ value });
    if (this.props.input) {
      this.props.input.onChange(phone.trim(value));
    } else {
      this.props.onChange(value, phone.trim(value));
    }
  };

  render() {
    const { ...props } = this.props;
    const { value } = this.state;

    return (
      <PhoneInput
        containerStyle={containerStyle}
        inputStyle={inputStyle}
        value={value}
        country="se"
        // onlyCountries={['se', 'no', 'dk', 'fi', 'de', 'gb']}
        inputExtraProps={{ id: 'phoneNumberField', autoComplete: 'off' }}
        {...props}
        onChange={this.handleChange}
      />
    );
  }
}
PhoneNumberInput.defaultProps = {
  addLabel: true,
  label: 'phoneNumber',
};

export const PhoneNumberFieldInput = t(({ source }) => (
  <Field
    name={source}
    component={PhoneNumberInput}
  />
));
PhoneNumberFieldInput.defaultProps = {
  addLabel: true,
  label: 'phoneNumber',
};

